// extracted by mini-css-extract-plugin
export var active = "CategoryList-module--active--PoS0L";
export var item = "CategoryList-module--item--OYWJK";
export var list = "CategoryList-module--list--zg8IG";